import Cookies from 'js-cookie';

class PoliciesController {

	// getters

	get isNoCookies() {
		return Cookies.get('__hs_opt_out') === 'yes';
	}

}

export default new PoliciesController();
